import React from "react";
import { Route, Routes } from "react-router-dom";
import { ProtectedRoute } from "../../shared";
import {
  EditBirthdayCouponsV2,
  BirthdayCouponDetailPageV2,
} from "./containers";

export const BirthdayCouponsV2 = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<BirthdayCouponDetailPageV2 />} />
        <Route element={<ProtectedRoute allowedRoute={["coupon-modify"]} />}>
          <Route path="/edit" element={<EditBirthdayCouponsV2 />} />
        </Route>
        <Route element={<ProtectedRoute allowedRoute={["coupon-view"]} />}>
          <Route path="/details/:id" element={<BirthdayCouponDetailPageV2 />} />
        </Route>
      </Routes>
    </>
  );
};
